import { preReveal, reveal } from '../modules/scroll-reveal';

import ScrollAction from "../modules/scroll-action";
import Sticky from "sticky-js";
import { jarallax } from "jarallax";
jarallax(document.querySelectorAll('.jarallax'));

new Sticky(".js-sticky");


window.addEventListener('load', () => {
	if (! window.matchMedia("(prefers-reduced-motion: reduce)").matches) reveal('.js-reveal');
});
// preReveal('.js-reveal');

// /** Hide */
// window.fade = function(el) {
// 	reveal('.js-reveal', { reset: true });
// }


if(document.querySelector('.js-site-header')){
	new ScrollAction({
		wrapper: ".js-site-header",
		offset: 0,
		classToAdd: "is-sticky",
		postClassToAdd: "is-post-sticky",
		preClassToAdd: "is-pre-sticky",
		prePostClassesTimeout: 1,
	}).init();
}
